import Home from './components/Home/Index';
import PageNotFound from './components/Shared/PageNotFound';

function App() {
  const path = window.location.pathname;
  if (path === '/' || path === '/home') return <Home />;
  return <PageNotFound />;
}

export default App;
